// constants
import { TestCategoryActionTypes } from './constants';
import { TestCategory as TestCategoryData } from 'src/types/testCategory';

export type TestCategoryActionType = {
    type:
        | TestCategoryActionTypes.API_RESPONSE_SUCCESS
        | TestCategoryActionTypes.API_RESPONSE_ERROR
        | TestCategoryActionTypes.ADD_TEST_CATEGORY
        | TestCategoryActionTypes.EDIT_TEST_CATEGORY
        | TestCategoryActionTypes.GET_TEST_CATEGORY
        | TestCategoryActionTypes.GET_TEST_CATEGORIES
        | TestCategoryActionTypes.RESET
        | TestCategoryActionTypes.RESET_SUCCESS
        | TestCategoryActionTypes.RESET_ERROR;
    payload: {} | string;
};

// common success
export const testCategoryApiResponseSuccess = (
    actionType: string,
    data: TestCategoryData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): TestCategoryActionType => ({
    type: TestCategoryActionTypes.API_RESPONSE_SUCCESS,
    payload: { actionType, data, message, code, error, success },
});
// common error
export const testCategoryApiResponseError = (
    actionType: string,
    data: TestCategoryData | {},
    message: string,
    code: number,
    error: string | boolean,
    success: boolean
): TestCategoryActionType => ({
    type: TestCategoryActionTypes.API_RESPONSE_ERROR,
    payload: { actionType, data, message, code, error, success },
});

export const addTestCategory = (params: any): TestCategoryActionType => ({
    type: TestCategoryActionTypes.ADD_TEST_CATEGORY,
    payload: params,
});

export const editTestCategory = (params: any): TestCategoryActionType => ({
    type: TestCategoryActionTypes.EDIT_TEST_CATEGORY,
    payload: params,
});

export const GetTestCategories = (params: any): TestCategoryActionType => ({
    type: TestCategoryActionTypes.GET_TEST_CATEGORIES,
    payload: params,
});

export const GetTestCategory = (params: any): TestCategoryActionType => ({
    type: TestCategoryActionTypes.GET_TEST_CATEGORY,
    payload: params,
});

export const resetTestCategory = (): TestCategoryActionType => ({
    type: TestCategoryActionTypes.RESET,
    payload: {},
});

export const resetTestCategorySuccess = (): TestCategoryActionType => ({
    type: TestCategoryActionTypes.RESET_SUCCESS,
    payload: {},
});
export const resetTestCategoryError = (): TestCategoryActionType => ({
    type: TestCategoryActionTypes.RESET_ERROR,
    payload: {},
});
